export enum ServerResultCode {
  SUCCESS = '40001', // 成功
  NOT_LOGIN = '40005', // 未登录
  NO_PERMISSION = '40006', // 无权限
  OVERDUE = '40007', // token已经过期
  UPGRADE = '40000', // 强制更新
  PARAMS_ERROR = '40003', // 接口参数错误
  DECLARE_MESSAGE = '40299' // 品种申报自定义提示信息
}

/**
 * @description:  http content type
 */
export enum ContentType {
  // json
  JSON = 'application/json;charset=UTF-8',
  // form-data qs
  FORM_URLENCODED = 'application/x-www-form-urlencoded;charset=UTF-8',
  // form-data  upload
  FORM_DATA = 'multipart/form-data;charset=UTF-8'
}

export enum HttpMethod {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
  PATCH = 'PATCH',
  HEAD = 'HEAD',
  OPTIONS = 'OPTIONS'
}
